import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import LocaleText from '../../LocaleText';

class Images extends React.Component {
    renderImage(image) {
        const isActive = _.isEqual(this.props.activeImage, image.id);
        const classes = ['menu__item'];
        let key = `image-${image.id}`;

        if (isActive) {
            classes.push('menu__item--active');
        }

        return (
            <li className={classes.join(' ')} key={key}>
                <div className="image" onClick={() => this.props.onImageSelect(image.id)}>
                    <img src={image.src} />
                    {/*<div className="image__control image__controls--remove"*/}
                    {/*onClick={() => this.props.onImageRemove(image.id)}>*/}
                    {/*<Isvg src="/svg/cancel.svg"/>*/}
                    {/*</div>*/}
                </div>
            </li>
        );
    }

    render() {
        const { images } = this.props;
        return (
            <div className="submenu__row image-selection">
                <ul className="menu">
                    <li className="menu__item">
                        <label htmlFor="image-upload">
                            <span className="label">
                                <LocaleText textKey="configurator.add.custom.image" />
                            </span>
                            <input
                                type="file"
                                accept="image/png,image/jpeg"
                                name="image"
                                id="image-upload"
                                onChange={this.props.onImageUpload}
                            />
                        </label>
                    </li>
                    {images.map(image => this.renderImage(image))}
                </ul>
            </div>
        );
    }
}

Images.propTypes = {
    activeImage: PropTypes.number,
    onImageUpload: PropTypes.func.isRequired,
    onImageSelect: PropTypes.func.isRequired,
    // onImageRemove: PropTypes.func.isRequired,
};

Images.defaultProps = {
    activeImage: null,
};

export default Images;
